
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dental-surgical-instruments",
      function () {
        return require("private-next-pages/dental-surgical-instruments.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dental-surgical-instruments"])
      });
    }
  